@for (pos of positions; track pos.key) {
  <p-toast [position]="pos.value" [key]="pos.key">
    <ng-template let-message pTemplate="message">
      <div class="flex align-items-center gap-1">
        <div
          class="icon flex align-items-center justify-content-center"
          [ngClass]="message.severity">
          @if (message.severity === 'success') {
            <i class="pi pi-check"></i>
          }
          @if (message.severity === 'error') {
            <i class="pi pi-times"></i>
          }
          @if (message.severity === 'info') {
            <i class="pi pi-info"></i>
          }
          @if (message.severity === 'warn') {
            <i class="text-icon exclamation-mark"></i>
          }
        </div>
        @if (message.summary || message.summary !== '') {
          <div class="title-wrapper">
            <div class="summary">{{ message.summary | translate }}</div>
          </div>
        }
        <div class="message-wrapper">
          <div class="message" [ngClass]="{ title: !message.summary || message.summary === '' }">
            {{ message.detail | translate }}
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>
}
